module.exports = __webpack_public_path__ + "img/mingShi_tc.eb772f05.png";